<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<bingliList></bingliList>
		</div>
		<div class="add" v-if="type==='edit'">
			<bingliEdit></bingliEdit>
		</div>
		<div class="add" v-if="type==='see'">
			<bingliEdit></bingliEdit>
		</div>
	</div>
</template>
<script>
	import bingliList from "../comp/bingli_list.vue"
	import bingliEdit from "../comp/bingli_edit.vue"
	// import bingliSee from "../comp/bingli_see.vue"
	export default {
		components:{bingliList,bingliEdit},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.yiliaoxin.bingliParams.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	width:100%;
	height: calc(100% - 145px);margin-top:12px;
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
